import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  complaint: undefined,
  ui: {
    uiState: UiState.Idle,
    error: null
  }
};

const getComplaintRequest = draft => {
  draft.ui.uiState = UiState.Pending;
};

const getComplaintSuccess = (draft, action) => {
  draft.ui.uiState = UiState.Success;
  draft.complaint = action.payload;
};

const getComplaintFailure = (draft, action) => {
  const {
    error
  } = action.payload;
  draft.ui.uiState = UiState.Failure;
  draft.ui.error = error;
};

const complaintSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    getComplaintRequest,
    getComplaintSuccess,
    getComplaintFailure
  }
});
export const {
  actions
} = complaintSlice;
export const plug = {
  [stateName]: complaintSlice.reducer
};
export default complaintSlice.reducer;